import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let TrendlinesDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-trendlines';
        }
    }
});
export const TrendlinesPlugin = {
    name: 'e-trendlines',
    install(Vue) {
        Vue.component(TrendlinesPlugin.name, TrendlinesDirective);
    }
};
export let TrendlineDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-trendline';
        }
    }
});
export const TrendlinePlugin = {
    name: 'e-trendline',
    install(Vue) {
        Vue.component(TrendlinePlugin.name, TrendlineDirective);
    }
};
